import React from 'react';
import classNames from 'classnames';

import './LeadActivityEmptyState.styles.scss';

type LeadActivityEmptyStateProps = {
  className?: string;
  title: string;
  description: string;
};

const LeadActivityEmptyState: React.FC<LeadActivityEmptyStateProps> = (
  props,
) => {
  const { className, title, description } = props;

  const classes = classNames('lead-activity-empty-state', className);

  return (
    <div className={classes}>
      <div className="lead-activity-empty-state__placeholder" />

      <p className="lead-activity-empty-state__title">{title}</p>
      <p className="lead-activity-empty-state__description">{description}</p>
    </div>
  );
};

export default LeadActivityEmptyState;
